enum EWaveLoaderVariant {
    DarkBlue = "darkBlue",
    LightBlue = "lightBlue",
    WhiteBlue = "whiteBlue"
}

export { EWaveLoaderVariant }
